
export const landingCheck = (to, from, next) => {
  const uuid = to.params.uuid || localStorage.getItem('web_user_uuid');
  const email = to.params.email || localStorage.getItem('email')
  if (uuid && email) next()
  else next({name: 'EmailAddress'})
}
